
import Vue from "vue";
import GenericPageBreadcrumb from "../../../components/navigation/GenericPageBreadcrumb.vue";
import ContactForm, {InquiryType} from "../../../components/util/ContactForm.vue";

export default Vue.extend({
  components: {
    ContactForm,
    GenericPageBreadcrumb,
  },
  scrollToTop: true,
  data() {
    return {
      InquiryType,
    };
  },
  mounted() {
    if (process.client) {
      document.getElementById("scrollTarget")?.scrollIntoView();
    }
  },
});
